import Broadcast from 'commons/js/Broadcast';
import { handleToast } from './Toast';
import { $get } from 'commons/js/utils/api';

function setGenerationStartListener(vm) {
  const toastData = {
    type: 'warning',
    content: `
      <h3 class="title">Suas etiquetas estão sendo geradas!</h3>
      <p class="subtitle">Acompanhe o progresso na página <a href="/painel/meus-envios">Meus envios</a></p>
    `,
  };

  const bc = new BroadcastChannel('background-tags');
  bc.onmessage = (message) => {
    if (message.data === 'start-generation') {
      handleToast(toastData, vm);
    }
  };
}

async function handleAllOrdersGenerated(eventData, vm) {
  
  if (window.location.pathname.includes('/imprimir')) {
    return;
  }

  const { hasError, everyNoPrintable, someNoPrintable } = eventData;

  let type = 'success';
  let title = 'Oba! Suas etiquetas ficaram prontas';
  let subtitle = 'Imprima suas etiquetas pela página <a href="/painel/meus-envios">Meus envios</a>';

  if (someNoPrintable) {
    title = 'Oba! Seus códigos e etiquetas ficaram prontos';
    subtitle = 'Imprima suas etiquetas e consulte seus códigos pela página <a href="/painel/meus-envios">Meus envios</a>';
  }

  if (everyNoPrintable) {
    title = 'Oba! Seus códigos ficaram prontos';
    subtitle = 'Consulte seus códigos pela página <a href="/painel/meus-envios">Meus envios</a>';
  }

  if (hasError) {
    type = 'warning';
    title = 'Opa! Nem todas as etiquetas foram geradas…';
    subtitle = 'Imprima suas etiquetas e confira o que deu errado na página Meus Envios.';

    if (someNoPrintable) {
      title = 'Opa! Nem todos os códigos e etiquetas foram gerados…';
      subtitle = 'Confira o que deu errado na página Meus Envios.';
    }

    if (everyNoPrintable) {
      title = 'Opa! Nem todos os códigos foram gerados…';
      subtitle = 'Consulte seus códigos e confira o que deu errado na página Meus Envios.';
    }
  }

  const toastData = {
    type,
    content: `
      <h3 class="title">${title}</h3>
      <p class="subtitle">${subtitle}</p>
    `,
  }

  handleToast(toastData, vm);
}

function addGenerationListeners(vm) {
  const channel= Broadcast.user(MEConfig.get('user.id'));
  channel.listen('.tag.done', (e) => handleAllOrdersGenerated(e, vm))
}

function orderGenerationWatcher(vm) {
  if (!MEConfig.get('user.id')) { // nao esta logado
    return;
  }
  addGenerationListeners(vm);
  setGenerationStartListener(vm);
};

export {
  orderGenerationWatcher,
};
